import React, { memo, useCallback } from 'react';
import { backlogCols, defaultChartOptions } from 'services/glass-management/glassManagement';
import { toast } from 'react-toastify';
import GlassCard from '../card/GlassCard';
import { themeColors } from 'helpers/utils';
import { getBarTrendline } from 'helpers/chartjs-utils';
import dayjs from 'dayjs';
import SLAChart from '../SLAChart';
import { useSelector, useDispatch } from 'react-redux';
import { openModal } from 'slices/glassDashboard/glassDataModalSlice';

const Backlog = () => {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(s => s.backlog);

    if (error)
        toast.error('Something went wrong!', error);

    const formatData = useCallback(tableData =>
        tableData?.map(x => {
            return {
                ...x,
                EmplasDeliveryDate: dayjs(x.EmplasDeliveryDate).format('DD-MM-YYYY'),
                PoRequiredDate: dayjs(x.PoRequiredDate).format('DD-MM-YYYY'),
            }
        }), [])

    const onChartClick = useCallback((e) => {
        if (data?.length && e?.name) {
            dispatch(openModal({
                modalData: formatData(data?.find(x => x.key === e?.name)?.jobs),
                modalLoading: false,
                modalShow: true,
                modalTitle: 'Backlog',
                tableCols: backlogCols,
            }));
        }
    }, [dispatch, data]);

    const showAllData = useCallback(() =>
        dispatch(openModal({
            modalData: formatData(Object.keys(data).flatMap(x => data[x].jobs)),
            modalLoading: false,
            modalShow: true,
            modalTitle: 'All Backlog',
            tableCols: backlogCols,
        })), [dispatch, data]);

    const getOptions = useCallback(() => {
        const xAxis = data?.map(x => x.key);
        const chartData = xAxis?.map((name, idx) => {
            return {
                value: data[idx]?.jobs?.length,
                name,
                itemStyle: {
                    color: themeColors.danger
                }
            };
        });

        return {
            ...defaultChartOptions,
            xAxis: {
                ...defaultChartOptions.xAxis,
                data: xAxis?.map(x => dayjs(x).format('ddd DD'))
            },
            series: [
                {
                    type: 'bar',
                    stack: 'Total',
                    data: chartData,
                },
                {
                    ...defaultChartOptions.series[1],
                    data: getBarTrendline(chartData?.map(x => x.value))
                }
            ],
        }
    }, [data]);
    const options = getOptions();

    return (
        <GlassCard
            md={6}
            lg={4}
            title="Backlog"
            heroValue={{ value: data?.reduce((a, b) => b.jobs.length + a, 0), prefix: '', class: 'text-danger', func: showAllData }}>
            <SLAChart loading={loading} options={options} onClick={onChartClick} />
        </GlassCard>
    );
}

export default memo(Backlog);